import React from "react";
import PropTypes from "prop-types";
import idx from "idx";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import { firebaseConnect } from "react-redux-firebase";
import camelCase from "lodash.camelcase";
import { push } from "react-router-redux";

import { EDITOR_ITEMS } from "../../constants";
import { findById, findPathById } from "../../helpers";
import Inspectors from "../../components/Inspector";
import ActionCreators from "../../redux/actions";
import EditorPanel from "../../components/EditorPanel";
import LoadingOverlay from "../../components/LoadingOverlay";

class Inspector extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: false
    };
    this.onValidSubmit = this.onValidSubmit.bind(this);
  }

  onValidSubmit(data, path) {
    this.setState({ isLoading: true });
    Object.keys(data).forEach(
      key => (data[key] === undefined ? delete data[key] : "")
    );
    // override if we have a callback function
    if (this.props.onValidSubmit) {
      this.props.onValidSubmit(data, path);
      this.setState({ isLoading: false });
    } else {
      const uploadFile = async file => {
        const { projectId } = this.props.match.params;
        const options = {
          name: uploadingFile => `${uploadingFile.name}/${Date.now()}`
        };

        return this.props.firebase.uploadFile(
          `files/${projectId}`,
          file,
          null,
          options
        );
      };
      const updates = {};
      const promises = {};
      Object.entries(data).map(([key, item]) => {
        if (Array.isArray(item)) {
          if (item.length > 1) {
          } else if (item[0] instanceof File) {
            promises[key] = uploadFile(item[0]);
          }
        } else {
          updates[key] = item;
        }
      });
      Promise.all(
        Object.entries(promises).map(([key, promise]) =>
          promise.then(result => {
            const { uploadTaskSnaphot: { downloadURL = {} } = {} } = result;
            updates[key] = { downloadURL };
          })
        )
      ).then(() => {
        this.props.firebase.updateWithMeta(path, updates);
        this.setState({ isLoading: false });
      });
    }
  }

  renderInspectorEditor() {
    const { currentItemId, currentItemType } = this.props.inspector;

    const project = idx(
      this.props,
      _ => _.projects[this.props.match.params.projectId]
    );
    let editorType = `${currentItemType}`;
    const element = findById(project, currentItemId);
    //console.log("inspector", currentItemId, editorType, project, element);
    const prefab = idx(project, _ => _.prefabs[element.prefab]);

    const path = findPathById(
      project,
      currentItemId,
      `projects/${this.props.match.params.projectId}`
    );

    if (
      (currentItemType === EDITOR_ITEMS.WIDGET ||
        currentItemType === EDITOR_ITEMS.MAP_WIDGET) &&
      project &&
      element
    ) {
      editorType = camelCase(`${element.type}-${currentItemType}`);
    }

    const InspectorEditor = Object.prototype.hasOwnProperty.call(
      Inspectors,
      editorType
    )
      ? Inspectors[editorType]
      : Inspectors.default;

    const { onValidSubmit, ...props } = this.props;

    return (
      <div>
        {this.state.isLoading && (
          <LoadingOverlay
            style={{ background: "rgba(255, 255, 255, 0.85)", zIndex: 999 }}
          />
        )}
        <InspectorEditor
          element={element}
          project={project}
          prefab={prefab}
          onValidSubmit={this.onValidSubmit}
          path={path}
          {...props}
        />
      </div>
    );
  }

  render() {
    const { currentItemType } = this.props.inspector;

    return (
      <EditorPanel
        hasFocus={this.props.hasFocus}
        onClick={this.props.onClick}
        title={
          currentItemType ? `${currentItemType} inspector` : this.props.title
        }
      >
        {this.renderInspectorEditor()}
      </EditorPanel>
    );
  }
}

Inspector.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  hasFocus: PropTypes.bool,
  inspector: PropTypes.shape({
    currentItemType: PropTypes.string
  }).isRequired
};

Inspector.defaultProps = {
  title: "Inspector",
  onClick: () => {},
  hasFocus: false
};

function mapStateToProps({ firebase, inspector }, props) {
  return {
    projects: firebase.data.projects,
    inspector
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(ActionCreators, dispatch),
    push: path => {
      dispatch(push(path));
    }
  };
}

export default compose(
  firebaseConnect(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Inspector);



// WEBPACK FOOTER //
// ./src/containers/Inspector/Inspector.js